import React from 'react';
import PropTypes from 'prop-types';

import FileCard from './file_card';

export class FilePanel extends React.Component {
  static propTypes = {
    files: PropTypes.array.isRequired,
    onRemove: PropTypes.func
  }

  getFileCount() {
    const { files } = this.props;

    if (files.length === 0) {
      return 'No Files';
    } else if (files.length === 1) {
      return '1 File';
    } else {
      return `${files.length} Files`;
    }
  }

  buildRemoveFileHandler = (file) => {
    const { onRemove } = this.props;

    if (onRemove) {
      return () => onRemove(file);
    }
  };

  render() {
    return (
      <React.Fragment>
        <h3>{this.getFileCount()} Uploaded</h3>
        {this.renderFileCards()}
      </React.Fragment>
    );
  }

  renderFileCards() {
    const { files } = this.props;
    return files.map((file) => {
      return (
        <FileCard
          file={file}
          key={file.id || `upload-${file.uploadId}`}
          onRemove={this.buildRemoveFileHandler(file)}
        />
      );
    });
  }
}
